module.exports = __webpack_public_path__ + "img/h8.f229adf7.jpg";